(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ul-color-previews"] && !Shopify.designMode) return;
  try {
    class ULColorPreviews extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.addEventListener('click', (event) => {
        const button = event.target.closest('a[data-variant-url]');
        if (!button) return;
        event.stopPropagation();
      }, options);
      this.addEventListener('pointerover', (event) => {
        if (event.pointerType !== 'mouse') return;
        const button = event.target.closest('a[data-variant-url]');
        if (button) this.selectColor(button);
      }, options);
      this.addEventListener('focusin', (event) => {
        const button = event.target.closest('a[data-variant-url]');
        if (button) this.selectColor(button);
      }, options);
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    async selectColor(button) {
      const card = this.closest('product-card');
      const gallery = card?.querySelector('[ref="cardGallery"]');
      const slideshow = gallery?.querySelector('slideshow-component');
      if (!card || !slideshow) return;
      this.pendingButton = button;
      await customElements.whenDefined('slideshow-component');
      if (!this.isConnected || this.pendingButton !== button) return;
      const mediaId = button.dataset.mediaId;
      const slide = Array.from(slideshow.querySelectorAll('slideshow-slide')).find(item => item.getAttribute('slide-id') === mediaId);
      if (!slide) return;
      gallery.removeAttribute('on:pointerenter');
      gallery.removeAttribute('on:pointerleave');
      for (const item of slideshow.querySelectorAll('slideshow-slide[variant-image]')) {
        item.hidden = item !== slide;
      }
      slide.hidden = false;
      slide.querySelector('img')?.removeAttribute('loading');
      slideshow.select({ id: mediaId }, undefined, { animate: false });
      for (const link of card.querySelectorAll('a[ref="productCardLink"], a[ref="cardGalleryLink"], a[ref="productTitleLink"]')) {
        link.href = button.dataset.variantUrl;
      }
      card.closest('product-card-link')?.setAttribute('data-featured-media-url', button.dataset.imageUrl);
      for (const item of this.querySelectorAll('a[data-variant-url]')) {
        item.setAttribute('aria-current', String(item === button));
      }
      const template = button.querySelector('template');
      for (const price of card.querySelectorAll('product-price [ref="priceContainer"]')) {
        price.replaceChildren(template.content.cloneNode(true));
      }
      for (const badge of card.querySelectorAll('.product-badges__badge')) {
        if (/^-\d+%$/.test(badge.textContent.trim())) {
          badge.hidden = !button.dataset.discount;
          if (button.dataset.discount) badge.textContent = '-' + button.dataset.discount + '%';
        }
      }
    }
  }
  if (!customElements.get('ul-color-previews')) {
    customElements.define('ul-color-previews', ULColorPreviews);
  }
  } catch(e) { console.error(e); }
})();

})();
